<template>
    <div class="card shadow-sm h-100 photo-tile photo-tile-upload">
        <div class="photo-tile-thumb">
            <div v-if="upload.file.type === PDF_TYPE"
                 class="d-flex flex-column align-items-center justify-content-center h-100 p-2 text-center text-muted small"
                 :class="{'opacity-50': upload.state === 'waiting' || upload.state === 'failed'}"
            >
                <span class="far fa-file-pdf fa-3x mb-2"></span>
                <span class="text-truncate w-100">{{ upload.file.name }}</span>
            </div>
            <img v-else
                 :src="upload.previewUrl"
                 :alt="upload.file.name"
                 :class="{'opacity-50': upload.state === 'waiting' || upload.state === 'failed'}"
            >
        </div>
        <div class="card-body p-2 small">
            <template v-if="upload.state === 'failed'">
                <div class="text-danger mb-2">
                    <span class="fas fa-exclamation-triangle me-1"></span>{{ upload.error }}
                </div>
                <button type="button" class="btn btn-sm btn-primary me-2" @click="$emit('retry')">
                    <span class="fas fa-redo me-1"></span>
                    Zkusit znovu
                </button>
                <button type="button" class="btn btn-sm btn-link" @click="$emit('discard')">
                    Odebrat
                </button>
            </template>
            <div v-else-if="upload.state === 'done'" class="text-success">
                <span class="fas fa-check me-1"></span>
                Nahráno
            </div>
            <div v-else-if="upload.state === 'uploading'">
                <span class="spinner-border spinner-border-sm me-2 align-middle" role="status"></span>
                {{ $t('form.navigation.uploading') }}&hellip;
            </div>
            <div v-else class="text-muted">
                <span class="fas fa-clock me-1"></span>
                Čeká na nahrání
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {PDF_TYPE} from '@/components/estimates/common/photos/texts';
import {Upload} from '@/composables/OrderedUploads';
import {defineComponent, PropType} from 'vue';

export default defineComponent({
    props: {
        upload: {type: Object as PropType<Upload<unknown>>, required: true},
    },
    emits: ['retry', 'discard'],
    setup() {
        return {PDF_TYPE};
    },
});
</script>
